import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

//*MUI
import { Box, Checkbox, Divider } from '@mui/material';

//*files
import cssClasses from './SustenancePayementPlans.module.css';

//*Redux
import { useDispatch, useSelector } from 'react-redux';
import action from '../../../Redux Store/actions';
import Button from '../../../Subcomponents/Button';
import { errorTost, successTost } from '../../../Services/Toast';
import {
  DeleteSelectedPlans,
  getAllPaymentPlans,
  getAllPaymentsForSustenance,
  getProjectByProjectName,
  PaymentRelationsData,
  SaveSelectedPaymentPlans,
} from '../../../Services/SustenanceService';
import { cloneDeep, differenceWith, isEqual, sortBy, uniqBy } from 'lodash';
import { dismissLoader, presentLoader } from '../../../Services/loader';
import { getAllPlansByProject } from '../../../Services/PaymentPlans';
import SelectSalesCp from '../../SelectSalesCp/SelectSalesCp';

function SustenancePaymentsPlans() {
  const dispatch = useDispatch();
  const [searchPlan, setSearchPlan] = useState('');
  const [allPlans, setAllPlans] = useState([]);
  const [allChildPlans, setAllChildPlans] = useState([]);
  const [projectName, setProjectName] = useState('');
  const { projectId } = useParams();
  let loggedInUser = {};

  loggedInUser = useSelector((state) => state.Auth.user);
  console.log(loggedInUser);

  useEffect(() => {
    dispatch(action.activeMenu('paymentplans'));
    getProjectData();
  }, []);

  useEffect(() => {
    if (allPlans.length === 0) {
      presentLoader();
      getAllPlansByProject(projectId)
        .then((resp) => {
          resp.data.forEach((ele, index) => {
            ele.id = ele.paymentPlanId;
            ele.show = true;
            ele.index = index;
            ele.isSelected = false;
            ele.unitType = ele.inventoryTypeId.type;
            ele.wingName = ele.wingId.wingName;
            ele.discount =
              ele.operation === 'Discount'
                ? '-  ' +
                  (ele.type === 'Fixed'
                    ? '₹ ' + numberWithCommas(ele.discount)
                    : ele.discount + '%')
                : '+  ' +
                  (ele.type === 'Fixed'
                    ? '₹ ' + numberWithCommas(ele.discount)
                    : ele.discount + '%');
          });
          console.log(resp.data);
          PaymentRelationsData(projectId)
            .then((res) => {
              if (res.data.length > 0) {
                res.data.forEach((ele, index) => {
                  resp.data[
                    resp.data.findIndex(
                      (e) => e.paymentPlanId === ele.paymentPlanId
                    )
                  ].isSelected = true;
                  resp.data = sortBy(resp.data, [
                    function (o) {
                      return !o.isSelected;
                    },
                  ]);
                  let newarr = cloneDeep(resp.data);
                  if (index === res.data.length - 1) {
                    // setAllExistingCp(resp.data.filter((e) => { return e.isSelected === true }))
                    setAllChildPlans([...resp.data]);
                    setAllPlans([...newarr]);
                    dismissLoader();
                  }
                });
              } else {
                let newarr = cloneDeep(resp.data);
                setAllChildPlans([...resp.data]);
                setAllPlans([...newarr]);
                dismissLoader();
              }
            })
            .catch((err) => {
              let newarr = cloneDeep(resp.data);
              setAllChildPlans([...resp.data]);
              setAllPlans([...newarr]);
              dismissLoader();
            });
        })
        .catch((err) => {
          dismissLoader();
        });
    } else {
      if (searchPlan === '') {
        allChildPlans.forEach((e, index) => {
          setAllChildPlans((pre) => {
            pre[index].show = true;
            return [...pre];
          });
        });
        allPlans.forEach((e, index) => {
          setAllPlans((pre) => {
            pre[index].show = true;
            return [...pre];
          });
        });
      } else {
        allPlans.forEach((ele) => {
          if (!ele.key.toUpperCase().includes(searchPlan.toUpperCase())) {
            setAllChildPlans((pre) => {
              pre[
                pre.findIndex((e) => e.paymentPlanId === ele.paymentPlanId)
              ].show = false;
              return [...pre];
            });
            setAllPlans((pre) => {
              pre[
                pre.findIndex((e) => e.paymentPlanId === ele.paymentPlanId)
              ].show = false;
              return [...pre];
            });
          } else {
            setAllChildPlans((pre) => {
              pre[
                pre.findIndex((e) => e.paymentPlanId === ele.paymentPlanId)
              ].show = true;
              return [...pre];
            });
            setAllPlans((pre) => {
              pre[
                pre.findIndex((e) => e.paymentPlanId === ele.paymentPlanId)
              ].show = true;
              return [...pre];
            });
          }
        });
        setAllChildPlans(
          sortBy(allChildPlans, [
            function (o) {
              return !o.isSelected;
            },
          ])
        );
      }
    }
  }, [searchPlan]);

  function getProjectData() {
    getProjectByProjectName(projectId).then((resp) => {
      console.log('Projects-Data', resp.data[0].projectName);
      setProjectName(resp.data[0]);
    });
  }

  const planGridColumns = [
    {
      field: 'key',
      headerName: 'Key',
      width: 400,
      renderCell: (params) => {
        return (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '1rem',
            }}
          >
            <div>
              <Checkbox
                checked={params.row?.isSelected}
                onChange={(e) => {
                  setAllChildPlans((pre) => {
                    pre[
                      pre.findIndex((e) => e.id === params.row.id)
                    ].isSelected =
                      !pre[pre.findIndex((e) => e.id === params.row.id)]
                        .isSelected;
                    return [...pre];
                  });
                }}
              />
            </div>
            <div>
              <p>{params.row.key}</p>
            </div>
          </div>
        );
      },
    },
    {
      field: 'title',
      headerName: 'Title',
      width: 290,
    },
    {
      field: 'wingName',
      headerName: 'Wing',
      width: 150,
    },
    {
      field: 'unitType',
      headerName: 'Unit Type',
      width: 150,
    },
    {
      field: 'discount',
      headerName: 'Discount',
      width: 170,
    },
  ];

  function SavePayments() {
    let allExistingPlans = allPlans.filter((e) => {
      return e.isSelected === true;
    });
    let arr = allChildPlans.filter((e) => {
      return e.isSelected === true;
    });
    if (arr.length === 0) {
      let newarr = cloneDeep(allPlans)
      setAllChildPlans([...newarr])
      errorTost("Please select atleast one Plan  and then save")
    } else {
      let newarr = cloneDeep(allChildPlans);
    setAllPlans([...newarr]);
    presentLoader();
    if (allExistingPlans.length > 0) {
      let insertarr = differenceWith(arr, allExistingPlans, isEqual);
      let deletearr = differenceWith(allExistingPlans, arr, isEqual);
      if (insertarr.length > 0) {
        insertarr.forEach((element, index) => {
          SaveSelectedPaymentPlans({
            projectId: projectId,
            paymentPlanId: element.paymentPlanId,
          }).then((resp) => {
            setAllPlans((pre) => {
              pre[
                pre.findIndex((e) => e.paymentPlanId === element.paymentPlanId)
              ].isSelected = true;
              return [...pre];
            });
            if (index === insertarr.length - 1) {
              if (deletearr.length > 0) {
                deletearr.forEach((ele, index2) => {
                  DeleteSelectedPlans(ele, projectId).then((res) => {
                    if (index2 === deletearr.length - 1) {
                      setAllPlans((pre) => {
                        pre[
                          pre.findIndex(
                            (e) => e.paymentPlanId === element.paymentPlanId
                          )
                        ].isSelected = false;
                        return [...pre];
                      });
                      successTost('Payment Plans saved successfully');
                      setSearchPlan('');
                      dismissLoader();
                    }
                  });
                });
              } else {
                successTost('Payment Plans saved successfully');
                setSearchPlan('');
                dismissLoader();
              }
            }
          });
        });
      } else if (deletearr.length > 0) {
        deletearr.forEach((ele, index2) => {
          DeleteSelectedPlans(ele, projectId).then((res) => {
            if (index2 === deletearr.length - 1) {
              setAllPlans((pre) => {
                pre[
                  pre.findIndex((e) => e.paymentPlanId === ele.paymentPlanId)
                ].isSelected = false;
                return [...pre];
              });
              successTost('Payment Plans saved successfully');
              setSearchPlan('');
              dismissLoader();
            }
          });
        });
      } else {
        successTost('Payment Plans saved successfully');
        setSearchPlan('');
        dismissLoader();
      }
    } else {
      arr.forEach((ele, index) => {
        SaveSelectedPaymentPlans({
          projectId: projectId,
          paymentPlanId: ele.paymentPlanId,
        }).then((resp) => {
          setAllPlans((pre) => {
            pre[
              pre.findIndex((e) => e.paymentPlanId === ele.paymentPlanId)
            ].isSelected = true;
            return [...pre];
          });
          if (index === arr.length - 1) {
            successTost('Payment Plans saved successfully');
            setSearchPlan('');
            dismissLoader();
          }
        });
      });
    }
    }
  }

  function numberWithCommas(x) {
    return x?.toString().replace(/\B(?=(?:(\d\d)+(\d)(?!\d))+(?!\d))/g, ',');
  }

  function selectAll() {
    setAllChildPlans((pre) => {
      pre.forEach((ele, index) => {
        pre[index].isSelected = true;
      });
      return [...pre];
    });
  }

  function deSelectAll() {
    setAllChildPlans((pre) => {
      pre.forEach((ele, index) => {
        pre[index].isSelected = false;
      });
      return [...pre];
    });
  }

  return (
    <Box className={cssClasses.Container}>
      <Box padding={'2rem'}>
        <Box className={cssClasses.HeaderTitle}>{projectName?.projectName}</Box>
        <Box className={cssClasses.SubTitle}>
          {projectName?.addressLine1},{projectName?.addressLine2},
          {projectName?.addressLine3}
        </Box>
      </Box>

      <Divider variant='middle' />

      <Box overflow={'auto'} height={'100%'}>
        <Box
          className={cssClasses.FlexRow}
          marginTop={'2rem'}
          padding={'0 2.4rem'}
        >
          <Box className={cssClasses.SubHeaderTitle}>Select Payment Plans</Box>
          {loggedInUser?.roleId?.accessibleTabs?.Sustenance['Payment Plans'][
            'Payment Plans Save'
          ]?.isAccessible && (
            <Box width={'fit-content'} marginLeft={'auto'} mr={2}>
              <Button
                style={{
                  color: "#fff",
                  backgroundColor: "#1570EF",
                  fontSize: "1.4rem",
                  lineHeight: "2rem",
                  fontFamily: "Roboto-Regular",
                }}
                padding={'0.8rem 2.6rem'}
                disable={allPlans.length === 0}
                btnName={'Save'}
                clicked={SavePayments}
              />
            </Box>
          )}
        </Box>

        <Box className={cssClasses.GridWrapper} padding={'0 2.4rem'}>
          <SelectSalesCp
            allChildRows={allChildPlans}
            allRows={allChildPlans.filter((e) => {
              return e.show === true;
            })}
            selectAll={selectAll} deSelectAll={deSelectAll}
            allColums={planGridColumns}
            setSearchSalesCp={setSearchPlan}
          />
        </Box>
      </Box>
    </Box>
  );
}

export default SustenancePaymentsPlans;
